"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var IdeationStatus = function IdeationStatus(_ref) {
  var topic = _ref.topic;

  if (!topic.ideationStatus && !topic.ideaStatus) {
    return null;
  }

  var IdeaStatus = Object.assign({
    bgColor: '',
    color: '',
    name: ''
  }, topic.ideationStatus);

  if (topic.ideaStatus) {
    IdeaStatus.bgColor = "#".concat(topic.ideaStatus.backgroundColor);
    IdeaStatus.color = "#".concat(topic.ideaStatus.textColor);
    IdeaStatus.name = topic.ideaStatus.name;
  }

  var name = IdeaStatus.name,
      bgColor = IdeaStatus.bgColor,
      color = IdeaStatus.color;
  return (0, _preact.h)("span", {
    style: {
      color: color,
      backgroundColor: bgColor
    },
    className: 'pill pill_idea pill--uppercase'
  }, name);
};

var _default = IdeationStatus;
exports.default = _default;